import { Reducer } from 'redux'
import { User, Transaction, ActionTypes, MERCHANT_USER_DETAILS_ACTIONS } from './types'

const initialState = {
  currentUser: {
    id: 0,
    nik: '',
    phoneNumber: '',
    fullName: '',
    accountNumber: '',
    joinDate: '',
    kycStatus: '',
  },
  userTransactions: [],
  totalTransactions: 0,
  isUserLoading: false,
  isTransactionTableLoading: true,
  currentPage: 1,
  pageLimit: 10,
  searchString: '',
}

type State = {
  currentUser: User
  userTransactions: Transaction[]
  totalTransactions: number
  isUserLoading: boolean
  isTransactionTableLoading: boolean
  currentPage: number
  pageLimit: number
  searchString: string
}

export const merchantUserDetails: Reducer<State, ActionTypes> = (state = initialState, action) => {
  switch (action.type) {
    case MERCHANT_USER_DETAILS_ACTIONS.SET_USER: {
      return {
        ...state,
        currentUser: action.currentUser,
        isUserLoading: action.isUserLoading,
      }
    }
    case MERCHANT_USER_DETAILS_ACTIONS.SET_IS_USER_LOADING: {
      return {
        ...state,
        isUserLoading: action.isUserLoading,
      }
    }

    case MERCHANT_USER_DETAILS_ACTIONS.SET_TRANSACTIONS_OF_USERS: {
      return {
        ...state,
        userTransactions: action.userTransactions,
        totalTransactions: action.totalTransactions,
      }
    }

    case MERCHANT_USER_DETAILS_ACTIONS.SET_IS_TRANSACTION_TABLE_LOADING: {
      return {
        ...state,
        isTransactionTableLoading: action.isTransactionTableLoading,
      }
    }

    case MERCHANT_USER_DETAILS_ACTIONS.SET_FILTERS: {
      return {
        ...state,
        [action.filterKey]: action.filterValues,
      }
    }

    case MERCHANT_USER_DETAILS_ACTIONS.RESET_TRANSACTIONS: {
      return {
        ...state,
        userTransactions: [],
        currentPage: 1,
        totalTransactions: 0,
      }
    }

    case MERCHANT_USER_DETAILS_ACTIONS.RESET_CURRENT_PAGE: {
      return {
        ...state,
        currentPage: 1,
      }
    }

    default:
      return state
  }
}
